import { kebabCase } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
const getPaths = (root, paths = []) => {
  const childPaths = [];
  const keys = Object.keys(root);
  keys.forEach(key => {
    const child = root[key];
    const keyPaths = paths.concat([child.title]);
    if (child.children) {
      const children = getPaths(child.children, keyPaths);
      childPaths.push(...children);
    } else {
      childPaths.push(keyPaths);
    }
  });
  return childPaths;
};
const selectionFromNestedPicker = root => {
  const result = {};
  const paths = getPaths(root || {});
  const [issueItem] = paths;
  if (paths.length !== 1) {
    result.item = `${paths.length} Items`;
  } else {
    result.item = issueItem.pop();
    result.group = issueItem.pop();
  }
  return result;
};
const selectionFromSinglePicker = tree => {
  if (!tree) {
    return '';
  }
  const [key] = Object.keys(tree);
  return (tree[key] || {}).title;
};
const IssuesRow = props => {
  const {
    data,
    hasActions,
    index,
    isSelected,
    onSelect,
    onClick
  } = props;
  const handleClick = onClick.bind(null, data.reportDocumentID, data.id);
  const items = useMemo(() => selectionFromNestedPicker(data.content.itemCollection), [data.content.itemCollection]);
  return /*#__PURE__*/React.createElement("tr", {
    className: `t-ir-${index}`,
    style: {
      height: '30px'
    }
  }, hasActions ? /*#__PURE__*/React.createElement("td", {
    "aria-label": "select-issue-checkbox",
    style: {
      width: '1px',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "t-ir-check",
    type: "checkbox",
    checked: isSelected,
    onChange: event => onSelect(data.id, event)
  })) : /*#__PURE__*/React.createElement("td", {
    "aria-label": "disabled-select-document-checkbox",
    style: {
      width: '1px',
      verticalAlign: 'middle'
    }
  }), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: `t-ir-label t-ir-label-${kebabCase(data.content.label)}`,
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, data.content.label)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-title",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, data.content.title)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-issue-items",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, items.item, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, items.group))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-issue-severity",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, selectionFromSinglePicker(data.content.severity))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-issue-status",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, selectionFromSinglePicker(data.content.status))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-first-name",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, `${data.firstName} ${data.lastName}`)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "t-ir-created",
    role: "link",
    tabIndex: "0",
    onClick: handleClick,
    onKeyPress: handleClick
  }, moment(data.created).format('MM/DD/YYYY'))));
};
IssuesRow.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.shape({
      itemCollection: PropTypes.shape({}),
      label: PropTypes.string,
      severity: PropTypes.shape({}),
      status: PropTypes.shape({}),
      title: PropTypes.string
    }),
    id: PropTypes.string,
    created: PropTypes.string,
    firstName: PropTypes.string,
    label: PropTypes.string,
    lastName: PropTypes.string,
    reportDocumentID: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  hasActions: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired
};
export default IssuesRow;